import { Component, ElementRef, HostListener, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { RecommendationsService } from '../../services/recommendations.service';
import { takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';

@Component({
    selector: 'app-browse',
    templateUrl: './browse.component.html',
    styleUrls: ['./browse.component.scss']
})
export class BrowseComponent implements OnInit, OnDestroy {

    destroy$: Subject<void> = new Subject();
    message: string;
    additionalResults: boolean;
    focusedMedia = 0;
    media = [];
    recommendationId: string;
    count = 30;
    page = 1;

    initialised = false;

    @ViewChild('scrollContainer') scrollContainer: ElementRef;

    constructor(private service: RecommendationsService,
                ) {
    }

    ngOnInit(): void {
        this.service.getRecommendationsV8(this.page).pipe(takeUntil(this.destroy$))
            .subscribe({
                next: recommendations => {
                    this.recommendationId = recommendations.recommendationId;

                    if (recommendations.media.length > 0) {
                        this.media = this.media.concat(recommendations.media);
                    } else {
                        this.message = 'No more results.';
                    }

                    this.initialised = true;
                    this.page++;
                },
                error: err => {
                    this.initialised = true;
                }
            });
    }

    ngOnDestroy() {
        this.destroy$.next();
        this.destroy$.complete();
    }

    onScroll() {
        if (!this.initialised || this.message === 'No more results.') {
            return;
        }

        const scroll = this.scrollContainer.nativeElement;

        let pos = (scroll.scrollTop) + scroll.offsetHeight;
        let max = scroll.scrollHeight;
        if (pos > max - 20) {
            if (this.additionalResults) {
                return;
            }

            this.additionalResults = true;
            this.service.getRecommendationsV8(this.page, this.recommendationId).subscribe(res => {
                this.additionalResults = false;

                if (res.media.length > 0) {
                    this.media = this.media.concat(res.media);
                } else {
                    this.message = 'No more results.';
                }
                this.page++;
            });
        }
    }
}
